export default __webpack_public_path__ + "static/media/nextTime.1ccc99b6.svg";